import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ backgroundColor: "#F6F6F6" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Delivering Excellence Across <span>Industries</span>
            </h2>
            <p>
              Get served at your doorstep – it’s no longer a luxury/customer
              desire but a must-fulfilled demand. This has transformed the
              businesses’ approach to consumer interaction, irrespective of your
              industry. Our on-demand mobile app development company builds and
              deploys business-specific, performant solutions across app stores.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Consult Your App Idea
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>On-Demand Ride-Booking Apps</h4>
                  <p>
                    Create interactive taxi apps with automated booking,
                    real-time tracking, customer support, and ride cancellation.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Healthcare Apps</h4>
                  <p>
                    Doctor on-demand app development to enhance connectivity
                    between patients and doctors, manage appointments, and track
                    medical history.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Fitness Training Apps</h4>
                  <p>
                    Develop fitness apps offering personalized training
                    sessions, progress tracking, and virtual coaching.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Medicine Delivery Apps</h4>
                  <p>
                    Ensure timely medicine delivery with prescription uploads,
                    real-time tracking, and online payments.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Event Planning Apps</h4>
                  <p>
                    Create event planning apps with features for booking
                    services, managing guest lists, and coordinating logistics.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Car Wash Apps</h4>
                  <p>
                    Create car wash apps that offer doorstep services with easy
                    booking and multiple request management.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Home Service Apps</h4>
                  <p>
                    Design apps connecting users with essential home services
                    like cleaning and pest control.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Repair & Maintenance Apps</h4>
                  <p>
                    Connect users with repair services featuring scheduling,
                    real-time tracking, and seamless payments.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Courier Service Apps</h4>
                  <p>
                    Develop courier apps with efficient dispatch, real-time
                    tracking, and secure delivery optimization.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Real Estate Apps</h4>
                  <p>
                    Develop real estate apps with virtual tours, property
                    management, and secure transaction handling.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Pet Care Apps</h4>
                  <p>
                    Create pet care apps offering services like grooming,
                    walking, and veterinary appointments with real-time updates.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Entertainment Apps</h4>
                  <p>
                    Build entertainment apps providing on-demand streaming,
                    event booking, and social sharing features.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Tutoring Platforms</h4>
                  <p>
                    Build tutoring platforms with scheduling, virtual
                    classrooms, progress tracking, and personalized learning.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Logistics Solutions</h4>
                  <p>
                    Optimize logistics with shipment tracking, predictive
                    analytics, route optimization, and automated billing.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Financial Management Apps</h4>
                  <p>
                    Create apps for managing finances, budgeting, investments,
                    and real-time transaction tracking.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Food Delivery Apps</h4>
                  <p>
                    Build apps with features like real-time tracking, inventory
                    management, and delivery agent coordination.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Beauty Service Apps</h4>
                  <p>
                    Connect users with beauty professionals for personalized
                    services, real-time bookings, and secure payments.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Grocery App</h4>
                  <p>
                    Build grocery delivery apps to help retailers meet diverse
                    needs and digitize their businesses.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Babysitting Apps</h4>
                  <p>
                    Build babysitting apps connecting parents with vetted
                    sitters, including real-time tracking and secure payments.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>On-Demand Laundry Apps</h4>
                  <p>
                    Develop laundry apps to manage orders, provide instant
                    services, and enable order tracking and online payments.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
